if (!customElements.get('wls-comparison-table')) {
  class WLSComparisonTable extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        section: 'wls-comparison-table',
        container: '.wls-comparison-table__container',
        table: '.wls-comparison-table__table',
        scrollable: 'scrollable',
      };

      this.onResize = this.checkScrollable.bind(this);
      this.onSectionLoad = this.handleSectionLoad.bind(this);
      this.imageLoadListeners = [];
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', this.onResize);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onResize);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.detachImageListeners();

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    init() {
      const section = this.querySelector(`.${this.classes.section}`);
      if (!section) return;

      this.container = section.querySelector(this.classes.container);
      this.table = this.container?.querySelector(this.classes.table);

      this.attachImageListeners();
      this.attachResizeObserver();
      this.scheduleScrollableCheck();
    }

    checkScrollable() {
      if (!this.container) return;

      // If section is still hidden/not laid out yet, retry next frame.
      if (this.container.clientWidth === 0) {
        this.scheduleScrollableCheck();
        return;
      }

      if (window.innerWidth < 1024) {
        const contentWidth = this.table ? this.table.scrollWidth : this.container.scrollWidth;
        const isScrollable = contentWidth > this.container.clientWidth + 1;
        if (isScrollable) {
          this.container.classList.add(this.classes.scrollable);
        } else {
          this.container.classList.remove(this.classes.scrollable);
        }
      } else {
        this.container.classList.remove(this.classes.scrollable);
      }
    }

    scheduleScrollableCheck() {
      window.requestAnimationFrame(() => {
        this.checkScrollable();
      });

      window.setTimeout(() => {
        this.checkScrollable();
      }, 250);
    }

    handleSectionLoad(event) {
      const sectionEl = event?.target?.closest?.('.shopify-section');
      if (sectionEl && !sectionEl.contains(this)) return;

      this.init();
    }

    attachResizeObserver() {
      if (!window.ResizeObserver || !this.container) return;

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver(() => {
        this.checkScrollable();
      });

      this.resizeObserver.observe(this.container);
      if (this.table) {
        this.resizeObserver.observe(this.table);
      }
    }

    attachImageListeners() {
      this.detachImageListeners();
      const images = this.querySelectorAll('img');

      images.forEach((image) => {
        if (image.complete) return;

        const handleLoad = () => {
          this.checkScrollable();
        };

        image.addEventListener('load', handleLoad, { once: true });
        this.imageLoadListeners.push({ image, handleLoad });
      });
    }

    detachImageListeners() {
      this.imageLoadListeners.forEach(({ image, handleLoad }) => {
        image.removeEventListener('load', handleLoad);
      });
      this.imageLoadListeners = [];
    }
  }

  customElements.define('wls-comparison-table', WLSComparisonTable);
}
